import { lazy } from 'react';

import { agentsTranslations as enAgents } from '@/lang/en/agents';
import { agentsTranslations as esAgents } from '@/lang/es/agents';
import { agentsTranslations as ptAgents } from '@/lang/pt/agents';
import { label, type FeatureModule } from '@/platform/app/contracts';
import { namespaceBundle } from '@/platform/i18n/types';

import { agentConfigSlice } from './domain/state/agentConfigSlice';
import { agentGenerationSlice } from './domain/state/agentGenerationSlice';
import { agentSourceSlice } from './domain/state/agentSourceSlice';

const AgentsNavigation = lazy(() =>
  import('./AgentsNavigation').then((m) => ({ default: m.AgentsNavigation })),
);

/** AI agents: list, wizard, config sections, sources, playground and stats. */
export const agentsModule: FeatureModule = {
  id: 'agents',
  routes: [{ path: 'agents/*', to: '/app/agents', Component: AgentsNavigation }],
  nav: [
    {
      sectionId: 'main',
      order: 10,
      to: '/app/agents',
      label: label('global', 'sidebar_agents_label'),
    },
  ],
  slices: [agentConfigSlice, agentSourceSlice, agentGenerationSlice],
  i18n: namespaceBundle('agents', { es: esAgents, en: enAgents, pt: ptAgents }),
};
